import { render, staticRenderFns } from "./GoalIcon.vue?vue&type=template&id=e30d4f4a&"
import script from "./GoalIcon.vue?vue&type=script&lang=js&"
export * from "./GoalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports